'use client';

import { BarStore } from '@winelivery-org/wl-client-sdk-js';
import { SearchProductAttribute } from '@winelivery-org/wl-client-sdk-js/src/models/search';
import { useMemo, useState } from 'react';
import { useTranslateCategoryName } from '../hooks';
import { BarCategory } from '../utils';
import Header from './components/Header';
import ProductListElement from './components/ProductListElement';

interface Props {
  store: BarStore;
  category: BarCategory;
  subcategories: SearchProductAttribute[];
}

export default function ProductList(props: Props) {
  useTranslateCategoryName(props.category);

  const [activeSubcategory, setActiveSubcategory] = useState<string | null>(
    null,
  );

  const products = useMemo(
    () =>
      activeSubcategory
        ? props.category.products.filter(
            (product) => product.subcategory.id === activeSubcategory,
          )
        : props.category.products,
    [activeSubcategory],
  );

  const handleSelectSubcategory = (subcategory: string) => {
    setActiveSubcategory(subcategory);
  };

  return (
    <div>
      <Header
        storeId={props.store.id}
        categoryName={props.category.name}
        subcategories={props.subcategories}
        activeSubcategory={activeSubcategory!}
        onClick={handleSelectSubcategory}
      />
      <div className="bg-white">
        <div className={'container mx-auto px-4'}>
          <ul className="pl-0 mb-0 py-8 grid grid-cols-1 gap-4 md:grid-cols-2">
            {products.map((product) => (
              <ProductListElement product={product} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
